import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/guards/auth.guard";
import { AutoLoginGuard } from "./services/guards/auto-login.guard";

const routes: Routes = [
  {
    path: "",
    // redirectTo: "landing",
    redirectTo: "agent-home",
    pathMatch: "full",
  },
  {
    path: "login",
    loadChildren: () =>
      import("./modules/login/login.module").then((m) => m.LoginModule),
    // canLoad: [AutoLoginGuard],
  },

  {
    path: "agent-home",
    loadChildren: () =>
      import("./modules/agent-home/agent-home.module").then(
        (m) => m.AgentHomePageModule
      ),
    // canLoad: [AuthGuard],
  },

  {
    path: "messages",
    loadChildren: () =>
      import(
        "./modules/agent/pages/main-tab-pages/chat/messages/messages.module"
      ).then((m) => m.MessagesPageModule),
    // canLoad: [AuthGuard],
  },

  // {
  //   path: "landing",
  //   loadChildren: () =>
  //     import("./common-pages/landing/landing.module").then(
  //       (m) => m.LandingPageModule
  //     ),
  //   canLoad: [AutoLoginGuard],
  // },


  {
    path: "splash-screen",
    loadChildren: () =>
      import("./modules/splash-screen/splash-screen.module").then(
        (m) => m.SplashScreenPageModule
      ),
  },
  {
    path: "matching",
    loadChildren: () =>
      import(
        "./modules/agent/pages/main-tab-pages/matching/matching.module"
      ).then((m) => m.MatchingPageModule),
  },
  { path: "**", redirectTo: "agent-home", pathMatch: "full" },
  {
    path: 'home',
    loadChildren: () => import('./modules/agent/pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'search-filter',
    loadChildren: () => import('./modules/agent/pages/search-filter/search-filter.module').then(m => m.SearchFilterPageModule)
  },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      // relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
